const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "수립연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      { component: "search-column-keyword", label: "검색조건", value: "column", query: { ck_t: "head", ck_k: "keyword" }, options: { hiddenList: ["수립연도", "작성일"] } },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    conditions.push({ key: "body.year", operator: "=", value: `${year}` });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "수립연도",
        key: "body.year",
      },
      {
        name: "시설명",
        key: "body.fields[%].field_name",
        style: { maxWidth: "260px", whiteSpace: "normal", wordBreak: "break-all" },
      },
      {
        name: "소관부서",
        key: "body.procFields[%].소관부서",
      },
      {
        name: "팀명",
        key: "body.stdInfo.section",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).year;
        case 1: {
          if (func.getContent(value).fields) {
            return func
              .getContent(value)
              .fields.map((e) => e.field_name)
              .join(", ");
          }
          return "";
        }
        case 2:
          if (func.getContent(value).fields) {
            const uniqueDept = [
              ...new Set(
                func.getContent(value).fields.map(function (e) {
                  return JSON.parse(e.meta).소관부서;
                })
              ),
            ];

            return uniqueDept.join(", ");
          }
          return "";
        case 3:
          return func.getContent(value).stdInfo.section;
        case 4:
          return func.getContent(value).stdInfo.writer_name;
        case 5:
          return func.getCreatedDate(value.created_at);
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
